import Vue from 'vue'
import Vuex from 'vuex'
import street from './modules/street'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    street,
    user
  }
})
